
export default {
    'Gutter': {
        Mobile: 10,
        Tablet: 5,
        Desktop: 5
    }
};